<mat-form-field class="fc-select" [appearance]="appearance" [ngClass]="class">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <mat-select
        placeholder="{{ placeholder }}"
        [disabled]="disabled"
        (selectionChange)="handleInput($event.value)"
        [attr.data-e2e-hook]="dataE2eHook"
    >
        <mat-option
            *ngFor="let option of options"
            [value]="option.value"
            class="fc-select-option"
            [attr.data-e2e-hook]="dataE2eHook + '-' + option.value"
        >
            {{ option.viewValue }}
        </mat-option>
    </mat-select>
    <mat-error [attr.data-e2e-hook]="errorE2eHook">{{ errorMessage }}</mat-error>
</mat-form-field>
